function initSlider(sectionSelector, listSelector, prevSelector, nextSelector, dotsSelector) {
  const section = document.querySelector(sectionSelector);
  if (!section) return;

  const list = section.querySelector(listSelector);
  const prevBtn = section.querySelector(prevSelector);
  const nextBtn = section.querySelector(nextSelector);
  const dotsContainer = section.querySelector(dotsSelector);

  if (!list) return;

  const items = list.children;
  const totalSlides = items.length;
  let current = 0;

  // --- ЛОГІКА ПЕРЕТЯГУВАННЯ МИШКОЮ (DRAG) ---
  let isDown = false;
  let startX;
  let scrollLeft;

  list.addEventListener('mousedown', (e) => {
    isDown = true;
    list.classList.add('active'); // можна додати в CSS cursor: grabbing
    startX = e.pageX - list.offsetLeft;
    scrollLeft = list.scrollLeft;
    // Вимикаємо плавну прокрутку під час тяжіння, щоб не було затримок
    list.style.scrollBehavior = 'auto';
  });

  list.addEventListener('mouseleave', () => {
    if (!isDown) return;
    isDown = false;
    snapToSlide();
  });

  list.addEventListener('mouseup', () => {
    if (!isDown) return;
    isDown = false;
    snapToSlide();
  });

  list.addEventListener('mousemove', (e) => {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX - list.offsetLeft;
    const walk = (x - startX); // швидкість прокрутки
    list.scrollLeft = scrollLeft - walk;
  });

  // Функція для "дотягування" до найближчого слайда після того, як відпустили мишку
 function scrollToSlide() {
    // Рахуємо ширину слайда разом із проміжком (gap)
    const item = list.querySelector('.reviews-step');
    const step = item.offsetWidth + 20; // 20 - це твій gap у CSS

    list.scrollTo({
      left: step * current,
      behavior: 'smooth'
    });
    updateDots();
}
  // ------------------------------------------

  if (dotsContainer) {
    dotsContainer.innerHTML = '';
    for (let i = 0; i < totalSlides; i++) {
      const dot = document.createElement('span');
      dot.classList.add('slider-dot');
      if (i === 0) dot.classList.add('active');
      dot.addEventListener('click', () => {
        current = i;
        scrollToSlide();
      });
      dotsContainer.appendChild(dot);
    }
  }

  function updateDots() {
    if (!dotsContainer) return;
    const dots = dotsContainer.querySelectorAll('.slider-dot');
    dots.forEach((dot, i) => {
      dot.classList.toggle('active', i === current);
    });
  }

function snapToSlide() {
    list.style.scrollBehavior = 'smooth';
    const item = list.querySelector('.reviews-step');
    const step = item.offsetWidth + 20;

    // Більш точне визначення поточного слайда
    current = Math.round(list.scrollLeft / step);

    if (current < 0) current = 0;
    if (current > totalSlides - 1) current = totalSlides - 1;

    scrollToSlide();
}

  const scroll = (direction) => {
    const max = totalSlides - 1;
    if (direction === 'next') current = Math.min(current + 1, max);
    else current = Math.max(current - 1, 0);
    scrollToSlide();
  };

  if (nextBtn) {
    nextBtn.addEventListener('click', () => {
      if (getComputedStyle(nextBtn).display !== 'none') scroll('next');
    });
  }

  if (prevBtn) {
    prevBtn.addEventListener('click', () => {
      if (getComputedStyle(prevBtn).display !== 'none') scroll('prev');
    });
  }
}

// Виклики залишаються такими ж
initSlider('.reviews-section', '.reviews-steps', '.btn-prev', '.btn-next', '.slider-dots');
